import { MouseEventHandler, ReactNode } from "react";

import { Alert, CloseButton, StyleProps } from "@/storybook-components";

interface AlertsPops extends StyleProps {
  title?: string | ReactNode;
  description?: string | ReactNode;
  onClose?: MouseEventHandler<HTMLButtonElement>;
  status: "warning" | "success" | "error" | "info";
}

const Alerts = ({
  title,
  status,
  onClose,
  description,
  ...rest
}: AlertsPops) => {
  return (
    <Alert.Root status={status} {...rest}>
      <Alert.Indicator />
      <Alert.Content>
        {title && <Alert.Title>{title}</Alert.Title>}
        {description && <Alert.Description>{description}</Alert.Description>}
      </Alert.Content>
      {onClose && <CloseButton ml="auto" onClick={onClose} />}
    </Alert.Root>
  );
};

export default Alerts;
